const DEFAULT_IMAGE = 'https://simplenexus.com/images/profile_sihlouette.png'

export class Profile {
  constructor (obj) {
    if (obj instanceof Object) {
      Object.assign(this, obj)
      this.full_name = `${obj?.name} ${obj?.last_name}`
      this.phone = obj?.phone || obj?.unformatted_phone?.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
      this.profile_image_url = obj?.profile_image_url || DEFAULT_IMAGE
      this.initials = this.full_name.split(' ')?.map(i => i.charAt(0))?.join('')?.toUpperCase()
      this.company_address = obj?.effective_company_address || '123 address'
    }
  }
}

class NullProfile {
  constructor () {
    this.name = 'Please'
    this.last_name = 'wait...'
    this.borrower_web_content_setting_splash_header = 'Please wait...'
    this.borrower_web_content_setting_splash_subheader = 'Loading'
    this.profile_image_url = DEFAULT_IMAGE
    this.company_address = '123 test'
  }
}

export class NullServicer extends NullProfile {
  constructor () {
    super()
    this.state_lics = '[]'
    this.effective_company_nmls = 'Loading'
  }
}

export class NullPartner extends NullProfile {}
